/**
 * Static suggestion catalogs for auto-fill inputs across the ATS.
 * These live in one place so agencies see the same picks on every form.
 * The AutocompleteInput component merges these with values already
 * present in the workspace's DB (surfaced by /api/suggestions/{field}).
 */

// Major Indian job markets + hybrid/remote variants that agencies use most
export const LOCATION_SUGGESTIONS = [
    "Remote",
    "Hybrid",
    "Bangalore",
    "Bengaluru",
    "Mumbai",
    "Delhi NCR",
    "New Delhi",
    "Gurgaon",
    "Gurugram",
    "Noida",
    "Hyderabad",
    "Pune",
    "Chennai",
    "Kolkata",
    "Ahmedabad",
    "Jaipur",
    "Chandigarh",
    "Kochi",
    "Indore",
    "Thiruvananthapuram",
    "Coimbatore",
    "Vadodara",
    "Nagpur",
    "Bhubaneswar",
    "Visakhapatnam",
    "Lucknow",
    "Surat",
    "Mysuru",
    // Common global markets Indian agencies staff for
    "Dubai, UAE",
    "Singapore",
    "London, UK",
    "New York, USA",
    "San Francisco, USA",
];

// Common Indian recruitment salary bands (in LPA / Cr terms).
export const SALARY_SUGGESTIONS = [
    "₹3-6 LPA",
    "₹6-10 LPA",
    "₹8-12 LPA",
    "₹10-15 LPA",
    "₹12-18 LPA",
    "₹15-25 LPA",
    "₹18-30 LPA",
    "₹25-40 LPA",
    "₹30-50 LPA",
    "₹40-60 LPA",
    "₹50-80 LPA",
    "₹60-100 LPA",
    "₹1-1.5 Cr",
    "₹1.5-2.5 Cr",
    "₹2.5+ Cr",
    "Competitive / Negotiable",
    "As per industry standards",
];

// Optional — reusable for future filters
export const INDUSTRY_SUGGESTIONS = [
    "Technology",
    "SaaS",
    "Fintech",
    "E-commerce",
    "Healthcare",
    "EdTech",
    "Manufacturing",
    "Banking",
    "Consulting",
    "Media",
    "Real Estate",
    "Retail",
    "Logistics",
    "Automotive",
    "Pharma",
    "Telecom",
    "Government",
    "NGO / Non-profit",
];

// V1.4 — curated top-level industry categories used for classifying Clients
// and driving the landing-page industry filter. Keep this list intentionally
// small so it stays scannable in the Client form select and on the landing
// page showcase. Free-text `industry` still exists on the Client model for
// sub-classification (e.g. "SaaS · dev tools").
export const INDUSTRY_TYPE_OPTIONS = [
    "Technology",
    "SaaS & Software",
    "Fintech & Banking",
    "E-commerce & Retail",
    "Healthcare & Pharma",
    "Education & EdTech",
    "Manufacturing",
    "Consulting & Services",
    "Media & Entertainment",
    "Real Estate & Construction",
    "Logistics & Supply Chain",
    "Automotive & Mobility",
    "Telecom",
    "Energy & Utilities",
    "Hospitality & Travel",
    "Government & Public Sector",
    "Non-profit & NGO",
    "Other",
];
